// 巡更点管理
const patrolPointManageJurisdiction = [
  { id: "025001001", label: "添加", children: [] },
  { id: "025001002", label: "修改", children: [] },
  { id: "025001003", label: "删除", children: [] },
  { id: "025001004", label: "导出", children: [] },
  { id: "025001005", label: "导入", children: [] }
];

// 班组管理
const teamManageJurisdiction = [
  { id: "025002001", label: "添加", children: [] },
  { id: "025002002", label: "修改", children: [] },
  { id: "025002003", label: "删除", children: [] }
];

// 巡更路线
const patrolRouteJurisdiction = [
  { id: "025003001", label: "添加", children: [] },
  { id: "025003002", label: "修改", children: [] },
  { id: "025003003", label: "删除", children: [] }
];

// 排班管理
const workforceManageJurisdiction = [
  { id: "025004001", label: "添加", children: [] },
  { id: "025004002", label: "修改", children: [] },
  { id: "025004003", label: "删除", children: [] }
];

// 智慧巡更
const keepWatchServiceJurisdictionChildren = [
  {
    id: "025001000",
    label: "巡更点管理",
    routerName: "patrol-point-manage",
    children: patrolPointManageJurisdiction
  },
  {
    id: "025002000",
    label: "班组管理",
    routerName: "team-manage",
    children: teamManageJurisdiction
  },
  {
    id: "025003000",
    label: "巡更路线",
    routerName: "patrol-route-manage",
    children: patrolRouteJurisdiction
  },
  {
    id: "025004000",
    label: "排班管理",
    routerName: "workforce-manage",
    children: workforceManageJurisdiction
  },
  {
    id: "025007000",
    label: "巡更任务",
    routerName: "patrol-task",
    children: []
  },
  {
    id: "025008000",
    label: "巡更报表",
    routerName: "patrol-report",
    children: []
  },
  {
    id: "025005000",
    label: "巡更记录",
    routerName: "keep-watch-record",
    children: []
  },
  {
    id: "025006000",
    label: "操作日志",
    routerName: "keep-watch-log",
    children: []
  }
];

const keepWatchServiceJurisdiction = {
  id: "025",
  label: "智慧巡更",
  children: keepWatchServiceJurisdictionChildren
};

export { keepWatchServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/keepWatchServiceJurisdiction.js